import { render, staticRenderFns } from "./PlayerRoute.vue?vue&type=template&id=2d921f78&scoped=true&"
import script from "./PlayerRoute.vue?vue&type=script&lang=js&"
export * from "./PlayerRoute.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRoute.vue?vue&type=style&index=0&id=2d921f78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d921f78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon,VPagination})
